import { Component, OnInit } from '@angular/core';
import {LoginService} from '../../../login-service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers:[LoginService]
})
export class DashboardComponent implements OnInit {
  totalList:any;
  tempTotals:any;
  sort=false;
  sortCoulmn='id';
  menuData: any;
  menuName: any;
  menuID: any;
  rolesList: any;
  MenuPermissions: any;
  roleID: any;
  userID:string;
  usersList: any;
  activeusersList: any;
  InactiveusersList: any;
  searchusers:any;
  searchactiveusers:any;
  searchinactiveusers:any;
  usersListDetails: any;
  activeListdetails:any;
  inactiveListdetails:any;
  userType: string;
  subCategorys=[];
  isDesc: boolean = false;
  column="";
  direction:number;
  arrow=true;
  subscriptionList:any;
  totalSubcriptionamount: any;
  deleteduserslist: any;
  subcategorieslength:any=[];
  categorieslist: any;
  parentcategoryList: any;
  categoryListDetails: any;
  subcategoriesList: any=[];
  skillsList: any;
  collabosList: any;
  collabosList1: any=[];
  collabosList2: any=[];
  initiatorslist: any=[];
  collaboratorslist: any=[];
  subcategoriesList1: any=[];
  constructor(private loginService:LoginService) 
  {
  this.userID=localStorage.getItem("userID");
  this.roleID=localStorage.getItem("roleID");
  this.userType=localStorage.getItem("userTypeid");
  this.MenuPermissions=localStorage.getItem("MenuPermissions");
  this.GetTotals();
  this.GetUsers();
  this.GetMenusByUserType(3);
  this.GetSubscriptions();
  }

  ngOnInit(): void {
    this.GetCollabos();
    this.getcategories();
    this.getSkills();
    this.GetActiveusers();
this.GetInactiveusers();
  }

  GetCollabos() {

    this.loginService.GetCollabos(this.userType).subscribe(data => {
      data = JSON.parse(data['_body']);
      this.collabosList = JSON.parse(JSON.stringify(data));
      this.collabosList1=this.collabosList.filter(x=>x.status==1)
      this.collabosList2=this.collabosList.filter(x=>x.status==1)
    })
  }

  getSkills(){
    
    this.loginService.Getskills(3).subscribe(data=>
      {
        data = JSON.parse(data['_body']);
        this.skillsList = data;
      });
   
 } 
  
sortMap(column:string,usersList){

  this.arrow = !this.arrow;
  this.isDesc = !this.isDesc; //change the direction    
  this.column = column;
  this.direction = this.isDesc ? 1 : -1;
let sortData:any;
sortData=usersList;
   this.sort = !this.sort;
   sortData.sort((a, b) => {
     let textA = '';
     let textB = '';
     if (a[column] !== undefined && b[column] !== undefined) {
       textA = a[column].toUpperCase();
       textB = b[column].toUpperCase();
       if (this.sort) {
         return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;
       } else {
         return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
       }
     }
   });

   return sortData;
   
  }
 GetSubscriptions(){
    this.loginService.GetSubscriptions().subscribe(data=>{
      data = JSON.parse(data['_body']);
      this.subscriptionList=JSON.parse(JSON.stringify(data));
      console.log(this.subscriptionList)
    })
  }

  getcategories() {
    this.subcategorieslength=[]
    this.loginService.GetCategories(this.userType,0).subscribe(data=>
      {
        data=JSON.parse(data['_body']);
        this.categorieslist=data;
        this.parentcategoryList=this.categorieslist.filter(x=>x.parentid==0);
        this.categoryListDetails=this.parentcategoryList;
        for(var i=0;i<this.parentcategoryList.length;i++){
          this.loginService.GetCategories(this.userType,this.parentcategoryList[i].id).subscribe(data=>
            {
              data=JSON.parse(data['_body']);
            let subcatlist=data;
            this.subcategoriesList=(subcatlist)
             for(var j=0;j<this.subcategoriesList.length;j++)
             {
              this.subcategoriesList1.push({
                name:this.subcategoriesList[j].category,
                date:this.subcategoriesList[j].createddate
              })
              
             }
        })
        }
        
      })
  }
GetTotals(){
  this.loginService.GetTotals().subscribe(data=>{
    data = JSON.parse(data['_body']);
    this.tempTotals = data;
    if(this.tempTotals.length>0){
      this.totalList=this.tempTotals[0];
    }
  });
}
GetUsers()
{
  this.loginService.GetUsers(3).subscribe(data=>
    {  
      data = JSON.parse(data['_body']);
            this.usersList=JSON.parse(JSON.stringify(data));
            this.usersListDetails=this.usersList;
            this.activeusersList=this.usersList.filter(x=>x.is_active=='y');
this.activeListdetails=this.activeusersList;
this.InactiveusersList=this.usersList.filter(x=>x.is_active=='n');
this.deleteduserslist=this.usersList.filter(x=>x.is_active=='d');
this.initiatorslist=this.usersList.filter(x=>x.user_type_id==1&&x.is_active=='y');
this.collaboratorslist=this.usersList.filter(x=>x.user_type_id==2&&x.is_active=='y');
this.inactiveListdetails=this.InactiveusersList;
    });
}
SearchUsers(){
  this.usersList = this.usersListDetails;
      let tempCompany = this.usersListDetails.filter(
        (item) => {
          return (
            (item.user_name !== null && item.user_name.toLowerCase().indexOf(this.searchusers.toLowerCase().trim()) > -1)||
            (item.user_type !== null && item.user_type.toLowerCase().indexOf(this.searchusers.toLowerCase().trim()) > -1)||
            (item.email !== null && item.email.toLowerCase().indexOf(this.searchusers.toLowerCase().trim()) > -1)
          );
        }
  
      );
      this.usersList = tempCompany;
    if(this.searchusers==""){
      this.GetUsers();
    }
}

GetActiveusers(){
  if(this.usersList.length>0)
this.activeusersList=this.usersList.filter(x=>x.is_active=='y');
this.activeListdetails=this.activeusersList;
}
SearchActiveUsers(){
  this.activeusersList = this.activeListdetails;
      let tempCompany = this.activeListdetails.filter(
        (item) => {
          return (
            (item.user_name !== null && item.user_name.toLowerCase().indexOf(this.searchactiveusers.toLowerCase().trim()) > -1)||
            (item.user_type !== null && item.user_type.toLowerCase().indexOf(this.searchactiveusers.toLowerCase().trim()) > -1)||
            (item.email !== null && item.email.toLowerCase().indexOf(this.searchactiveusers.toLowerCase().trim()) > -1)
          );
        }
  
      );
      this.activeusersList = tempCompany;
    if(this.searchactiveusers==""){
      this.GetUsers();
    }
}
GetInactiveusers(){
  if(this.usersList.length>0)
  this.InactiveusersList=this.usersList.filter(x=>x.is_active=='n');
  this.inactiveListdetails=this.InactiveusersList;
}
SearchInactiveUsers(){
  this.InactiveusersList = this.inactiveListdetails;
      let tempCompany = this.inactiveListdetails.filter(
        (item) => {
          return (
            (item.user_name !== null && item.user_name.toLowerCase().indexOf(this.searchinactiveusers.toLowerCase().trim()) > -1)||
            (item.user_type !== null && item.user_type.toLowerCase().indexOf(this.searchinactiveusers.toLowerCase().trim()) > -1)||
            (item.email !== null && item.email.toLowerCase().indexOf(this.searchinactiveusers.toLowerCase().trim()) > -1)
          );
        }
  
      );
      this.InactiveusersList = tempCompany;
    if(this.searchinactiveusers==""){
      this.GetUsers();
    }
}
GetRoles(){
  this.loginService.GetRoles(this.userType).subscribe(data=>
    {  
      data = JSON.parse(data['_body']);
            this.rolesList=JSON.parse(JSON.stringify(data));
let filteRole=this.rolesList.filter(x=>x.RoleID.toString()==this.roleID.toString())
if(filteRole.length>0){
  this.MenuPermissions=JSON.parse(filteRole[0].MenuJson);
}
});
}
GetMenusByUserType(userTypeID){
  this.loginService.GetMenusByUserType(userTypeID).subscribe(data=>
      {
  
  data = JSON.parse(data['_body']);
  this.menuData=JSON.parse(JSON.stringify(data));
  let tempdata=this.menuData;
  this.menuData=tempdata.filter(x=>x.menu_name.toString().toLowerCase()==='dashboard');
  if(this.menuData.length>0)
    {
  this.menuName=this.menuData[0]["menu_name"];
  this.menuID=this.menuData[0]["menu_id"];
    }
  

    
  
      });
      }


}
